const basico4 = {
  titulo: `JavaScript: Resolver y rechazar promesas (resolve y reject)`,
  problemas: [
      {
          codigo: 1,
          descripcion: `Lo que vimos hasta ahora como crear una promesa y luego de cumplida llamar al método resolve que llamará al método then de la promesa. Pero habrá situaciones cuando la promesa no pueda ser resuelta en dichas situaciones deberemos llamar al método reject y éste llamara a un método llamado catch de la promesa.
Vamos a hacer un problema muy sencillo para comprender el orden de ejecución de los métodos.
Problema: Plantear una promesa que reciba dos enteros y luego de 5 segundos nos informe de la división de los mismos, si el segundo parámetro es 0, indicar que no se puede cumplir la promesa.           
<code>
console.log(1)
function dividir(x, y) {
  console.log(2)
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      console.log(4)
      if (y != 0) {
        console.log(5)
        resolve(x / y)
      } else {
        console.log(5)
        reject("No se puede dividir por 0")
      }
    }, 5000)
  })
}

dividir(10, 0).then(x => {
  console.log(6)
  console.log(x)
}).catch(error => {
  console.log(6)
  console.log(error)
})
console.log(3)
</code>
Hemos dispuesto una serie de console.log con números que nos ayudan a comprender el orden de ejecución de los métodos.
Como vemos disponemos la función callback del constructor de la Promise con dos parámetros resolve y reject. En los ejemplos anteriores solo trabajamos con el primer parámetro (resolve)
Luego llamamos a la función setTimeout que espera 5 segundos, si el segundo parámetro recibe un cero, procedemos a llamar a reject, en caso contrario como en problemas anteriores llamamos a resolve.
Además de llamar al método then, procedemos a llamar al método catch para capturar el error si lo ubiera.
`,
          programa: `const arreglo = [1]

function dividir(x, y) {
  arreglo.push(2)
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      arreglo.push(4)
      if (y != 0) {
        arreglo.push(5)
        resolve(x / y)
      } else {
        arreglo.push(5)
        reject("No se puede dividir por 0")
      }
    }, 500)
  })
}

dividir(10, 0).then(x => {
  arreglo.push(x)
}).catch(error => {
  arreglo.push(error)
  console.log(arreglo)
})
arreglo.push(3)`,
          solucion: "[1, 2, 3, 4, 5, 'No se puede dividir por 0']"
      }, {
          codigo: 2,
          descripcion: `Tener en cuenta que podemos disponer cualquier nombre a los parámetros de la función callback de la promesa, pero para que sea más fácil de entender, vamos a llamar a los parámetros resolve (resolver) y reject (rechazar).`,
          programa: `const arreglo = [1]
function dividir(x, y) {
  arreglo.push(2)
  return new Promise((resolver, rechazar) => {
    setTimeout(() => {
      arreglo.push(4)
      if (y != 0) {
          arreglo.push(5)
          resolver(x / y)
      } else {
          arreglo.push(5)
          rechazar("No se puede dividir por 0")
      }
    }, 500)
  })
}

dividir(10, 0).then(x => {
  arreglo.push(x)
}).catch(error => {
  arreglo.push(error)
  console.log(arreglo)
})
arreglo.push(3)`,
          solucion: "[1, 2, 3, 4, 5, 'No se puede dividir por 0']",
      }, {
        codigo: 3,
        descripcion: `Cuando tenemos promesas encadenadas, inmediatamente se dispara el reject de una promesa, el resto no se ejecuta y salta directamente al catch.
<code>
function dividir(x, y) {
return new Promise((resolver, rechazar) => {
  setTimeout(() => {
      if (y != 0) {
        resolver(x / y)
      } else {
        rechazar("No se puede dividir por 0")
      }
    }, 500)
  })
}

dividir(800, 2).then(x => {
  console.log(x)
  return dividir(x, 2)
}).then(x => {
  console.log(x)
  return dividir(x, 2)
}).then(x => {
  console.log(x)
  return dividir(x, 0)
}).then(x => {
  console.log(x)
  return dividir(x, 2)
}).then(x => {
  console.log(x)
  return dividir(x, 2)
}).catch(error => {
  console.log(error)
})
</code>
En pantalla aparece el resultado de dividir 800 con respecto a 2, 400 respecto a 2 y seguidamente tratamos de dividir 200 con respecto a 0, se ejecuta reject y se dispara el método catch.
`,
        programa: `const arreglo=[]

function dividir(x, y) {
  return new Promise((resolver, rechazar) => {
    setTimeout(() => {
      if (y != 0) {
        resolver(x / y)
      } else {
        rechazar("No se puede dividir por 0")
      }
    }, 500)
  })
}

dividir(800, 2).then(x => {
  arreglo.push(x)
  return dividir(x, 2)
}).then(x => {
  arreglo.push(x)
  return dividir(x, 2)
}).then(x => {
  arreglo.push(x)
  return dividir(x, 0)
}).then(x => {
  arreglo.push(x)
  return dividir(x, 2)
}).then(x => {
  arreglo.push(x)
  return dividir(x, 2)
}).catch(error => {
  arreglo.push(error)
  console.log(arreglo)
})`,
        solucion: "[400, 200, 100, 'No se puede dividir por 0']",
    }
  ]
}

export default basico4;

